import { render, staticRenderFns } from "./SingleSelectVeranstaltung.vue?vue&type=template&id=f6cd2450"
import script from "./SingleSelectVeranstaltung.vue?vue&type=script&lang=js"
export * from "./SingleSelectVeranstaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports